// This is develop environment used for development on https://info-dev.intowords.com.
import { NgxLoggerLevel } from 'ngx-logger';
import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version,
  name: 'dev',
  production: false,
  availableLanguages: [
    'da-DK',
    'nb-NO',
    'nn-NO',
    'sv-SE',
    'en-GB',
  ],
  logLevel: NgxLoggerLevel.DEBUG,
  location: 'https://status-dev.intowords.com',
  UrlEndpoints: {
    cloudapp: 'https://cloudapp-dev.intowords.com/',
    finger: 'https://10-finger-dev.intowords.com',
    statusData: 'https://statusapi.dev.vitecmv.com/api/ReleaseInfo',
  },
};
